import { gql } from "apollo-boost"

export const CREATE_MINISTRATION_PLAN = gql`
  mutation CreateMinistrationPlan(
    $submissionId: ID!,
    $createMinistrationPlanData: CreateMinistrationPlanInput!
  ) {
    CreateMinistrationPlan(
      submissionId:$submissionId
      createMinistrationPlanData: $createMinistrationPlanData
    ) {
      id
      createdAt
      deletedAt
      modifiedAt
      monthlyReviewDueDate
      finalReportDueDate
    }
  }
`
